// extracted by mini-css-extract-plugin
export var content = "_5p-3";
export var list = "_5p-4";
export var settingsContent = "_5p-7";
export var settingsPanel = "_5p-8";
export var state = "_5p-6";
export var triggerBadge = "_5p-2";
export var triggerButton = "_5p-1";
export var triggerShell = "_5p-0";
export var unreadDot = "_5p-5";